import Select, { components } from "react-select";

const DEFAULT_MAX_MENU_HEIGHT = 140;

const InfiniteMenuList = (props) => {
  const handleScroll = (event) => {
    const target = event?.target;
    if (!target) return;
    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 5;
    if (isBottom) {
      props.selectProps?.onMenuScrollToBottom?.();
    }
  };

  return (
    <components.MenuList
      {...props}
      innerProps={{
        ...props.innerProps,
        onScroll: handleScroll,
      }}
    />
  );
};

const buildMenuStyles = (maxMenuHeight, styles) => {
  const safeMaxHeight = Number.isFinite(maxMenuHeight)
    ? maxMenuHeight
    : DEFAULT_MAX_MENU_HEIGHT;

  return {
    ...styles,
    menuList: (base, state) => {
      const baseFromCaller = styles?.menuList ? styles.menuList(base, state) : base;
      return {
        ...baseFromCaller,
        maxHeight: safeMaxHeight,
        overflowY: "auto",
      };
    },
  };
};

const InfiniteScrollSelect = ({
  maxMenuHeight = DEFAULT_MAX_MENU_HEIGHT,
  styles,
  components: userComponents,
  menuShouldScrollIntoView = false,
  ...props
}) => {
  const mergedComponents = userComponents?.MenuList
    ? userComponents
    : { ...userComponents, MenuList: InfiniteMenuList };

  return (
    <Select
      {...props}
      maxMenuHeight={maxMenuHeight}
      menuShouldScrollIntoView={menuShouldScrollIntoView}
      styles={buildMenuStyles(maxMenuHeight, styles)}
      components={mergedComponents}
    />
  );
};

export default InfiniteScrollSelect;
